import { BrowsableOffice, ErrorResponse, LoginResponse } from "../../api";
import {
    Session,
    deleteSessionCookie,
    getSessionCookie,
    isLoggedIn,
    setLastLoginOtp,
    setSessionCookie,
} from "../../components/cookies";
import { VersionData } from "../../interfaces";
import { Permission } from "../../literals";
import { clearStore, commonSlice, store } from "../../store";
import { api } from "../common/make_api";
import { ResourceType, StatusType, sendLog } from "../common/send_log";
import { initDriverList } from "../driver_list_menu/select";
import { selectShiftsReport as selectReserveShiftsReport } from "../reserve/shifts_report";
import { selectShiftReports } from "../shift_monitoring/shift_select/shift_reports";
import { selectCapacities } from "../usage_based_capacity/select";
import { selectPaymentsSummary } from "../usage_based_summary/select";
import {
    selectWeeklyReports,
    selectWeeklyReportsOfficeId,
} from "../weekly/weeklyreport";

export async function serverLogout(): Promise<void> {
    const commonAPI = api.getAuthenticationApi();
    commonAPI.logout();
}

// TODO: loginAPIのリスポンス(office_id/office_ids/company_id周り）をもっとintuitiveにする
export async function Login(): Promise<void> {
    try {
        store.dispatch(commonSlice.actions.startLoading());
        const req = store.getState().login.login;
        const res = await api
            .getAuthenticationApi()
            .login({ loginRequest: req });
        console.debug("InitProcess: response of login:", res);
        api.setBasicAuth(res.consoleUserId, res.sessionKey);

        setSessionCookie({
            sessionKey: res.sessionKey,
            consoleUserId: res.consoleUserId,
            consoleUserName: res.consoleUserName,
            consoleUserPermissions: res.consoleUserPermissions as Permission[],
        });
        await initialize(res);
        //
    } catch (err) {
        if (err["status"] && err["status"] == 500) {
            console.log("Got 500 error response...", err);
            store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        console.log("response of login error:", res, err);
        // "No OTP token provided through required."
        if (res.code && res.code === 40105) {
            setLastLoginOtp(true);
            store.dispatch(commonSlice.actions.setRedirect("/login_otp"));
        }
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}

async function initialize(res: LoginResponse): Promise<void> {
    if (!isLoggedIn()) {
        console.debug("InitProcess: no session. Must log in. returning.");
        return;
    }

    try {
        const session = getSessionCookie();
        console.debug("InitProcess: Got session cookie..", session);
        await setupStore(session, res.browsableOffices);
        const permission = session.consoleUserPermissions;
        if (permission.includes("monitoring")) {
            // FIXME 初期表示はweekly_reportなのにshift_reportも検索していて無駄
            // 本来的には左メニュークリックタイミングで検索をかけるべき
            // マニュアルがクリック時にロードしているのでそれに合わせる
            selectWeeklyReportsOfficeId(res.browsableOffices[0].officeId);
            selectWeeklyReports();
            selectShiftReports();
        } else if (permission.includes("reserve")) {
            selectReserveShiftsReport();
        } else if (permission.includes("chargeable")) {
            // FIXME 初期表示と関係ないテーブルも検索していて無駄
            // 本来的には左メニュークリックタイミングで検索をかけるべき
            // マニュアルがクリック時にロードしているのでそれに合わせる
            selectPaymentsSummary();
            selectCapacities();
        }
    } catch (err) {
        console.log("Got this error from initialize:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
        }
    }
}

export async function setupStore(
    session: Session,
    browsableOffices: BrowsableOffice[]
) {
    let officeIds: number[] = [];
    let officeNames: string[] = [];
    browsableOffices.forEach((r) => {
        officeIds.push(r.officeId);
        officeNames.push(r.officeName);
    });
    // 初期選択はリストの最初のoffice
    let selectedOfficeId = officeIds[0];
    const commonAPI = api.getCommonAPI();
    const drivers = await commonAPI.getDrivers({ officeIds: officeIds });
    const vi = (await commonAPI.getversions()) as VersionData;
    store.dispatch(
        commonSlice.actions.setup([
            selectedOfficeId,
            officeIds,
            officeNames,
            drivers,
            vi,
        ])
    );

    await initDriverList(selectedOfficeId);
    console.debug("login Drivers response.......", drivers);
    const permissions = session.consoleUserPermissions;
    setLastLoginOtp(!permissions.includes("otp_free"));
    return officeIds;
}

/**
 * ユーザの権限応じた初期画面のパスを返す。
 *  - requestPath: ユーザーからの要求パス。現状reserveの地図以外は全て無視される。
 */
export function OpeningScreenPath(requestPath: string): string {
    const permission = getSessionCookie().consoleUserPermissions;
    if (permission.includes("monitoring")) {
        return "/weekly_report";
    } else if (permission.includes("reserve")) {
        if (requestPath.startsWith("/reserve/trip/map")) {
            return requestPath;
        }
        return "/reserve/shifts";
    } else if (permission.includes("chargeable")) {
        return "/payments/summary";
    }
    return "/";
}

export function Logout(): void {
    const permissions = getSessionCookie().consoleUserPermissions;
    const typeOfLogin =
        permissions.includes("otp_free") || permissions.length == 0
            ? "/login"
            : "/login_otp";

    sendLog(ResourceType.SHIFTS_MONITORING, StatusType.LOGOUT);
    serverLogout();
    clearStore();
    deleteSessionCookie();

    store.dispatch(commonSlice.actions.setRedirect(typeOfLogin));
}
